import { memo, useCallback, useEffect, useState } from "react";
import { getCompanyConfigurationService } from "../../../../../shared/services/uploadFiles";

function Company(companyProps) {
  const { setCompany } = companyProps;

  useEffect(() => {
    fetchGetCompany();
  }, []);

  const fetchGetCompany = useCallback(async () => {
    try {
      const response = await getCompanyConfigurationService();

      setCompany(response);
    } catch (error) {
      setCompany(null);
      console.warn("Ocurred error getting company", error);
    }
  }, []);

  return null;
}
export default memo(Company);
